import { GamepadRoundIcon } from './GamepadRoundIcon';

/**
 * author: Haley Halcyon
 * id 3AD46D54-4369-483C-A0B5-E03D7CF62F3B
 * name gamepad-round
 * version: 3.6.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/gamepad-round.svg
 * tags
 * - Gaming / RPG 
 */
export const ControllerRoundIcon = GamepadRoundIcon;
export default ControllerRoundIcon